import { getFullNameFormat, useMobileOfficeConfigurationQuery } from '../queries/useMobileOfficeConfigurationQuery';
export var useConsultantNameFormatters = function useConsultantNameFormatters() {
  var _useMobileOfficeConfi = useMobileOfficeConfigurationQuery(),
    configuration = _useMobileOfficeConfi.data;
  var fullNameFormat = getFullNameFormat(configuration);
  return {
    getFormattedConsultantName: function getFormattedConsultantName(firstName, lastName) {
      return fullNameFormat.replace('{FirstName}', firstName !== null && firstName !== void 0 ? firstName : '').replace('{LastName}', lastName !== null && lastName !== void 0 ? lastName : '')
      // not supported formats should be cleaned
      .replace('{Greeting}', '').replace('{Gender}', '');
    },
    getCapitalisedInitials: function getCapitalisedInitials(firstName, lastName) {
      return fullNameFormat.replaceAll(' ', '').replace('{FirstName}', (firstName !== null && firstName !== void 0 ? firstName : '').slice(0, 1).toUpperCase()).replace('{LastName}', (lastName !== null && lastName !== void 0 ? lastName : '').slice(0, 1).toUpperCase())
      // Gender or Greeting are ignored in initials
      .replace('{Greeting}', '').replace('{Gender}', '');
    }
  };
};